import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Video } from 'lucide-react';

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';

export function YimMeetLayout() {
  const { t } = useTranslation();

  if (!googleClientId) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-primary-950 px-4 text-center text-white">
        <p className="text-sm text-white/70">{t('yimMeet.configMissing')}</p>
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="flex h-dvh flex-col overflow-hidden bg-gradient-to-b from-primary-800 via-primary-900 to-primary-950 text-white">
        <Helmet>
          <title>{t('yimMeet.pageTitle')}</title>
          <meta name="theme-color" content="#1e3a8a" />
        </Helmet>

        <header className="flex shrink-0 items-center justify-center gap-2 border-b border-white/10 px-4 py-3">
          <Video className="h-5 w-5 text-primary-300" aria-hidden />
          <span className="text-sm font-black uppercase tracking-widest text-white">
            {t('yimMeet.brand')}
          </span>
        </header>

        <main className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          <div className="mx-auto flex w-full max-w-3xl flex-1 flex-col px-3 py-6 sm:px-4">
            <Outlet />
            <footer className="mt-auto pt-8 text-center">
              <Link
                to="/"
                className="text-xs text-white/40 hover:text-white/70 focus-visible:ring-2 focus-visible:ring-accent-400"
              >
                {t('yimMeet.backToSite')}
              </Link>
            </footer>
          </div>
        </main>
      </div>
    </GoogleOAuthProvider>
  );
}

export default YimMeetLayout;
